import React, { Component, PropTypes, useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import "./menu.scss";
import dashboardIcon from "./dashboard-icon.svg";
import errorsIcon from "./errors-icon.svg";
import robotsIcon from "./robots-icon.svg";
import rowsIcon from "./rows-icon.svg";
import tasksIcon from "./tasks-icon.png";
import weatherIcon from "./weather-icon.svg";
import wifiIcon from "./wifi-icon.png";
import wifiSelectedIcon from "./wifi-icon-selected.png";
import settingsIcon from "./settings-icon.svg";
import availabilityIcon from "./availability-icon.png";
import dailyActivityIcon from "./daily-activity-icon.png";

import reportsIcon from "./reports-icon.png";
import reportsSelectedIcon from "./reports-selected-icon.png";

import messagesIcon from "./messages-icon.png";

import dashboardSelectedIcon from "./dashboard-icon-selected.svg";
import errorsSelectedIcon from "./errors-icon-selected.svg";
import robotsSelectedIcon from "./robots-icon-selected.svg";
import rowsSelectedIcon from "./rows-icon-selected.svg";
import tasksSelectedIcon from "./tasks-icon-selected.png";
import settingsSelectedIcon from "./settings-icon-selected.svg";
import weatherSelectedIcon from "./weather-icon-selected.svg";
import availabilitySelectedIcon from "./availability-selected-icon.png";
import dailyActivitySelectedIcon from "./daily-activity-selected-icon.png";
import messagesSelectedIcon from "./messages-selected-icon.png";

import logo from "./logo.svg";
import { menuItemSelected } from "./menuItemSelectedAction";
import {
  LOCAL_STORAGE_PROJECT,
  LOCAL_STORAGE_TOKEN_KEY,
  LOCAL_STORAGE_USER_KEY,
  MENU_URLS,
} from "../../consts";
import { withNavigation } from "../withNavigate";
import {
  getCurrentProject,
  navigateToProjectRoute,
  isProjectRequiredRoute,
} from "../../utils/projectUtils";

const MenuItems = [
  {
    text: "Dashboard",
    idleIcon: dashboardIcon,
    selectedIcon: dashboardSelectedIcon,
    url: "/dashboard",
  },
  {
    text: "Robots",
    idleIcon: robotsIcon,
    selectedIcon: robotsSelectedIcon,
    url: ["/robots", "/robot", "/vehicle"],
  },
  {
    text: "Robots & Site Info",
    idleIcon: rowsIcon,
    selectedIcon: rowsSelectedIcon,
    url: "/robot-site-info",
  },
  {
    text: "Robot Settings",
    idleIcon: settingsIcon,
    selectedIcon: settingsSelectedIcon,
    url: "/robot-settings",
  },
  {
    //#979797        #e36510
    text: "Tasks",
    idleIcon: tasksIcon,
    selectedIcon: tasksSelectedIcon,
    url: "/tasks",
  },
  {
    text: "Messages",
    idleIcon: messagesIcon,
    selectedIcon: messagesSelectedIcon,
    url: "/messages",
  },
  {
    text: "Errors",
    idleIcon: errorsIcon,
    selectedIcon: errorsSelectedIcon,
    url: "/errors",
  },
  {
    text: "Error Resolution",
    idleIcon: errorsIcon,
    selectedIcon: errorsSelectedIcon,
    url: "/error-resolution",
  },
  {
    text: "Daily Activity",
    idleIcon: dailyActivityIcon,
    selectedIcon: dailyActivitySelectedIcon,
    url: "/daily-activity",
  },
  {
    text: "Availability",
    idleIcon: availabilityIcon,
    selectedIcon: availabilitySelectedIcon,
    url: "/availability",
  },
  {
    text: "Reports",
    idleIcon: reportsIcon,
    selectedIcon: reportsSelectedIcon,
    url: "/reports",
  },
  {
    text: "Weather",
    idleIcon: weatherIcon,
    selectedIcon: weatherSelectedIcon,
    url: "/weather",
  },
  {
    text: "Repeaters",
    idleIcon: wifiIcon,
    selectedIcon: wifiSelectedIcon,
    url: "/repeaters",
  },
  {
    text: "Settings",
    idleIcon: settingsIcon,
    selectedIcon: settingsSelectedIcon,
    url: "/settings",
  },
];

const VehicleItems = [
  {
    text: "Dashboard",
    idleIcon: dashboardIcon,
    selectedIcon: dashboardSelectedIcon,
    url: "/vehicles/dashboard",
  },
  {
    text: "Vehicles",
    idleIcon: robotsIcon,
    selectedIcon: robotsSelectedIcon,
    url: "/vehicles/list",
  },
];

const MenuComponent = (props) => {
  const [items, setItems] = useState(MenuItems);
  const [selectedItem, setSelectedItem] = useState(props.menuItem);
  const [project, setProject] = useState();
  const [user, setUser] = useState();
  const [expandedItems, setExpandedItems] = useState({});

  const blockedForOwners = [
    "Robots & Site Info",
    "Robot Settings",
    "Tasks",
    "Messages",
    "Errors",
    "Error Resolution",
    "Reports",
    "Repeaters",
    "Settings",
  ];

  const blockedForOperator = ["Error Resolution"];

  const blockedForTechnician = ["Error Resolution"];

  // Helper function to check if any child URL matches current path
  const isParentSelected = (item) => {
    if (!item.children) return false;
    return item.children.some((child) => {
      if (child.url instanceof Array) {
        return child.url.indexOf(window.location.pathname) !== -1;
      }
      return window.location.pathname === child.url;
    });
  };

  // Helper function to apply blocking rules to nested items
  const applyBlockingRules = (items, blocked) => {
    return items.map((item) => {
      if (item.children) {
        // Apply blocking to children
        const updatedChildren = item.children.map((child) => ({
          ...child,
          hide: blocked.includes(child.text),
        }));

        // If all children are hidden, hide the parent too
        const allChildrenHidden = updatedChildren.every((child) => child.hide);

        return {
          ...item,
          children: updatedChildren,
          hide: allChildrenHidden,
        };
      } else {
        return {
          ...item,
          hide: blocked.includes(item.text),
        };
      }
    });
  };

  useEffect(() => {
    if (!localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY)) {
      this.props.navigate("/signin");
      return;
    }

    const project = getCurrentProject(); // Use URL parameter to get correct project
    const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_KEY));

    let items = [...MenuItems];
    if (project && project.arrayType !== "fixed") {
      items = VehicleItems;
    }

    const blocked = [];
    if (user.role === "projectOwner") {
      blocked.push(...blockedForOwners);
    } else if (user.role === "operator") {
      blocked.push(...blockedForOperator);
    } else if (user.role === "technician") {
      blocked.push(...blockedForTechnician);
    }

    items = applyBlockingRules(items, blocked);

    setItems(items);
  }, []);

  const menuItemClicked = (e, index, item) => {
    if (item.isParent) {
      e.preventDefault(); // Prevent link navigation for parent items
      // Toggle expansion for parent items
      setExpandedItems((prev) => ({
        ...prev,
        [item.text]: !prev[item.text],
      }));
    } else {
      e.preventDefault(); // Prevent default link navigation
      setSelectedItem(index);
      let url = item.url instanceof Array ? item.url[0] : item.url;
      navigateWithProject(url);
    }
  };

  const childItemClicked = (e, parentIndex, childIndex, childItem) => {
    e.preventDefault(); // Prevent default link navigation
    let url = childItem.url instanceof Array ? childItem.url[0] : childItem.url;
    navigateWithProject(url);
  };

  const navigateWithProject = (url) => {
    if (window.location.pathname === url) return;

    // Check if this route requires a project
    const requiresProject = [
      "/dashboard",
      "/robots",
      "/robot",
      "/vehicle",
      "/vehicles/dashboard",
      "/vehicles/list",
      "/robot-site-info",
      "/robot-settings",
      "/tasks",
      "/messages",
      "/errors",
      "/error-resolution",
      "/daily-activity",
      "/availability",
      "/reports",
      "/weather",
      "/settings",
      "/repeaters",
    ].some((route) => url === route || url.startsWith(route + "/"));

    if (requiresProject) {
      const currentProject = getCurrentProject();
      if (currentProject) {
        navigateToProjectRoute(url, currentProject._id);
      } else {
        // No project selected, redirect to projects page
        window.location.href = "/projects";
      }
    } else {
      window.location.href = url;
    }
  };

  const logoClicked = (e) => {
    e.preventDefault();
    window.location.href = "/projects";
  };

  const getMenuItemUrl = (item) => {
    let url = item.url instanceof Array ? item.url[0] : item.url;

    // Check if this route requires a project
    const requiresProject = [
      "/dashboard",
      "/robots",
      "/robot",
      "/vehicle",
      "/vehicles/dashboard",
      "/vehicles/list",
      "/robot-site-info",
      "/robot-settings",
      "/tasks",
      "/messages",
      "/errors",
      "/error-resolution",
      "/daily-activity",
      "/availability",
      "/reports",
      "/weather",
      "/settings",
      "/repeaters",
    ].some((route) => url === route || url.startsWith(route + "/"));

    if (requiresProject) {
      const currentProject = getCurrentProject();
      if (currentProject) {
        const fullUrl = new URL(url, window.location.origin);
        fullUrl.searchParams.set("project", currentProject._id);
        return fullUrl.toString();
      }
    }

    return url;
  };

  return (
    <div className="menu">
      <a className="logo" href="/projects" onClick={logoClicked}>
        <img src={logo} />
      </a>
      <div className="items">
        {items.map((item, index) => {
          if (item.hide) return null;

          if (item.isParent) {
            const isExpanded = expandedItems[item.text];
            const isSelected = isParentSelected(item);

            return (
              <div key={index}>
                <a
                  href="#"
                  className={
                    "item parent-item" + (isSelected ? " selected" : "")
                  }
                  onClick={(e) => menuItemClicked(e, index, item)}
                >
                  <img src={isSelected ? item.selectedIcon : item.idleIcon} />
                  <span className="text">{item.text}</span>
                  <span className={`arrow ${isExpanded ? "expanded" : ""}`}>
                    ▼
                  </span>
                </a>
                {isExpanded && (
                  <div className="sub-items">
                    {item.children.map((childItem, childIndex) => {
                      if (childItem.hide) return null;

                      let isChildSelected =
                        childItem.url instanceof Array
                          ? childItem.url.indexOf(window.location.pathname) !==
                            -1
                          : window.location.pathname === childItem.url;

                      return (
                        <a
                          key={childIndex}
                          href={getMenuItemUrl(childItem)}
                          className={
                            "item sub-item" +
                            (isChildSelected ? " selected" : "")
                          }
                          onClick={(e) =>
                            childItemClicked(e, index, childIndex, childItem)
                          }
                        >
                          <img
                            src={
                              isChildSelected
                                ? childItem.selectedIcon
                                : childItem.idleIcon
                            }
                          />
                          <span className="text">{childItem.text}</span>
                        </a>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          } else {
            let isSelected =
              item.url instanceof Array
                ? item.url.indexOf(window.location.pathname) !== -1
                : window.location.pathname === item.url;

            return (
              <a
                key={index}
                href={getMenuItemUrl(item)}
                className={"item" + (isSelected ? " selected" : "")}
                onClick={(e) => menuItemClicked(e, index, item)}
              >
                <img src={isSelected ? item.selectedIcon : item.idleIcon} />
                <span className="text">{item.text}</span>
              </a>
            );
          }
        })}
      </div>
    </div>
  );
};

export default withNavigation(MenuComponent);
